import React from 'react';
import { getAmount } from './../../../lib/api/api.data';
import { depositMoneyInt, depositMoneyDecimal } from "./../../../lib/reg";
import { getInputVal, formatAmount } from "./../../../lib/utils";
import { getFEWalletParams } from "../../../../platform.pay.config";

import translate from "./../../../lib/translate/TranslateJs";


class WithdrawalMoney extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            money: ""
        }

    }

    render() {

        const {
            Item,
            Input,
            MoneyTip
        } = this.props;
        const FEWalletParams = getFEWalletParams();
        const { label, tip, allowDecimals, setting, typeCode } = this.props;
        const minBal = formatAmount(setting && setting.minBal),
            maxBal = formatAmount(setting && setting.maxBal);

        return <>
            <Item
                fieldName="money"
                label={label || translate("金额")()}
                getValueFromEvent={(value) => {
                    if (allowDecimals) {
                        let formatValue = value.replace(/[^\d.]/g, "");
                        const parts = formatValue.split('.');
                        if (parts.length > 2) {
                            formatValue = parts[0] + '.' + parts.slice(1).join('');
                        }
                        if (parts[1] && parts[1].length > 2) {
                            formatValue = parts[0] + '.' + parts[1].slice(0, 2);
                        }
                        return formatValue;
                    } else {
                        return value.replace(/[^\d]/g, "");
                    }
                }}
                rules={[{
                    required: true,
                    message: translate("请输入金额")()
                }, {
                    validator: (rule, value) => {
                        if (value) {
                            if (!(allowDecimals ? depositMoneyDecimal : depositMoneyInt).test(value)) {
                                return Promise.reject(translate("金额格式错误")());
                            }
                            // CXFUN88-3602，擋0+數字
                            if (/^0\d+/.test(value)) {
                                return Promise.reject(translate("金额格式错误")());
                            }
                            // M3 1 = 1,000
                            // const actualMoney = FEWalletParams.languageType === "M3" ? Number(value) * 1000 : value;
                            if (value < (setting?.minBal || 0)) {
                                return Promise.reject(translate("最低提款金额￥<#0#>")(minBal));
                            }
                            if (value > (setting?.maxBal || 0)) {
                                return Promise.reject(translate("最高提款金额￥<#0#>")(maxBal));
                            }
                            if (this.props.uniqueAmountStatus && value.toString().substr(-1) === "0") {
                                return Promise.reject(translate("金额必须以 \"1-9\" 结尾")())
                            }
                        }

                        this.setState({money: value});

                        return Promise.resolve();
                    }
                }]}
                extra={FEWalletParams.languageType === "M3" ? <MoneyTip type="vnMoneyTip" tip={translate("注：如提币金额为50万，请仅输入500")()} /> : null}
                //extra={FEWalletParams.languageType === "M3" && this.state.money ? <MoneyTip type="VND" tip={("=" + formatAmount(this.state.money * 1000) + "VND")} /> : null}
            >
                {(control, meta) => {
                    return <Input
                        inputmode="numeric"
                        allowDecimals={allowDecimals}
                        value={control.value}
                        haserr={meta.errors.length ? "has" : ""}
                        placeholderTextColor="#BCBEC3"
                        placeholder={translate(typeCode==="LB" ? "最小提款限额 <#0#>，最大提款限额 <#1#>" : "最小crypto提款限额 <#0#>，最大crypto提款限额 <#1#>")(minBal, maxBal)}
                        onChange={(v) => {
                            const ControlValue = typeof v === "object" ? v.target.value : v;
                            typeof this.props.onChange === "function" && this.props.onChange(ControlValue);
                            control.onChange(ControlValue);
                        }}
                    />
                }}
            </Item>
        </>
    }
}

export default WithdrawalMoney;
